import React, { useEffect, useRef } from 'react';
import { useAppContext } from '../core/context';
import { Routes } from '../Routes';
import { prettyPrintMsisdn } from '../core/util/msisdn';
import { useLanguageContext } from '../core/locale/LanguageContext';
import { errorReasons, viewEvents } from '../core/services/mixpanelEvents';
import StatusViewLegacy from './StatusViewLegacy';
import StatusViewRedesigned from './StatusViewRedesigned';
import { useFlag } from '../feature-flags';

function StatusView(): React.ReactNode {
  const context = useAppContext();
  const showNewDesign = useFlag('redesign');
  const viewLoadedRef = useRef(false);

  useEffect(() => {
    if (context.claims && !viewLoadedRef.current) {
      viewLoadedRef.current = true;
      context.mixpanel?.trackViewLoad(viewEvents.LANDING_PAGE_COUNTDOWN_VIEWED);
    }
  }, [context]);
  const languageContext = useLanguageContext();

  if (!context.claims) {
    context.setRoute(Routes.ERROR, errorReasons.CLAIMS_MISSING);
    return <></>;
  }

  const submittedPhoneNumber = context.submittedPhoneNumber;
  const phoneNumber =
    submittedPhoneNumber && submittedPhoneNumber.number ?
      prettyPrintMsisdn(submittedPhoneNumber)
    : languageContext.getLocalizedText('statusNumberFallback');

  const childProps = {
    phoneNumber,
    expiresAt: context.claims.expiryTime,
    startTime: context.claims.issuedAt,
  };

  return showNewDesign ?
      <StatusViewRedesigned {...childProps} />
    : <StatusViewLegacy {...childProps} />;
}

export default StatusView;
